import React from 'react';
import Contact from '../components/Contact/Contact';

const ContactPage = () => {
  return (
    <div style={{ marginTop: '151px' }}>
      <Contact />
    </div>
  );
};

export default ContactPage;
